import clsx from 'clsx';
import { FC } from 'react';

import { WithClassName } from '../../../../../types/react';
import { Flex } from '../../../common/Flex';
import { Text } from '../../../common/Text';

import styles from './PayoutsDemoForm.module.scss';

type PayoutsDemoFormProps = WithClassName & {};

export const PayoutsDemoForm: FC<PayoutsDemoFormProps> = (props) => {
  const { className } = props;

  return (
    <Flex className={clsx(styles.root, className)} alignItems="center" justifyContent="center">
      <Flex className={styles.form} direction="column" gap={6}>
        <Text type="medium18" color="white">
          Payment
        </Text>

        <Flex direction="column" gap={2}>
          <Text className={styles.label}>Wallet 1</Text>

          <Flex className={styles.input} alignItems="center">
            <Text type="medium18" color="white">
              555 555.00
            </Text>
          </Flex>
        </Flex>

        <Flex direction="column" gap={2}>
          <Text className={styles.label}>Total</Text>

          <Flex className={styles.input} alignItems="center" />
        </Flex>

        <Flex className={styles.button} alignItems="center" justifyContent="center">
          <Text type="medium18" color="green">
            Pay
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
